var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupHorizontalIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 566.194,
    height: 161.425,
    viewBox: "0 0 566.194 161.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 566.194,
    height: 161.425,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(10.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-10.194)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M80.594,166.9a39.547,39.547,0,1,1-39.547-39.547A39.547,39.547,0,0,1,80.594,166.9",
    transform: "translate(9.956 -90.796)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 39.547,
    cy: 39.547,
    r: 39.547,
    transform: "matrix(0.003, -1, 1, 0.003, 11.355, 115.55)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M207.375,351.89l-30.986,16.643L145.4,385.176l1.08-35.156,1.08-35.156,29.906,18.513Z",
    transform: "translate(-92.64 -224.483)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M207.375,351.89l-30.986,16.643L145.4,385.176l1.08-35.156,1.08-35.156,29.906,18.513Z",
    transform: "translate(-92.64 -224.483)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1403.99,97.459a6.678,6.678,0,1,1-6.678-6.678,6.678,6.678,0,0,1,6.678,6.678",
    transform: "translate(-926.358 -64.723)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M1403.99,97.459a6.678,6.678,0,1,1-6.678-6.678A6.678,6.678,0,0,1,1403.99,97.459Z",
    transform: "translate(-926.358 -64.723)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1498.881,162.805l11.52-88.988-52.223-28.448",
    transform: "translate(-974.513 -32.346)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1395.476,45.368l-25.245,10.7,25.744,15.988Z",
    transform: "translate(-911.811 -32.346)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1395.476,45.368l-25.245,10.7,25.744,15.988Z",
    transform: "translate(-911.811 -32.346)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 33.908,
    height: 7.207,
    transform: "translate(507.189 129.545)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 33.908,
    height: 7.207,
    transform: "translate(507.189 129.545)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1152.369,350.415a20.48,20.48,0,1,1-20.48-20.48,20.48,20.48,0,0,1,20.48,20.48",
    transform: "translate(-748.913 -235.229)",
    fill: "#cfcfcf",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 20.48,
    cy: 20.48,
    r: 20.48,
    transform: "translate(362.496 94.706)",
    fill: "none",
    stroke: "#020202",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1127.086,369.128c8.334,1.275,14.288,4.846,15.188,9.93,1.451,8.184-10.927,15.732-27.418,18.656s-30.848.115-32.3-8.068c-.81-4.569,2.632-9.393,8.7-13.272",
    transform: "translate(-728.26 -263.172)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1280.442,446.973a4.3,4.3,0,1,1-4.3-4.3,4.3,4.3,0,0,1,4.3,4.3",
    transform: "translate(-863.296 -315.606)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.3,
    cy: 4.3,
    r: 4.3,
    transform: "translate(408.548 127.067)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M1047.3,446.973a4.3,4.3,0,1,1-4.3-4.3,4.3,4.3,0,0,1,4.3,4.3",
    transform: "translate(-697.073 -315.606)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.3,
    cy: 4.3,
    r: 4.3,
    transform: "translate(341.624 127.067)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M579.583,9.457S515.168,32.149,509.225,32.68s-39.512,4.491-38.676,13.57c.8,8.673,24.412.79,34.158,1.739,7.769.757,11.62,8.154,18.825,24.913,5.4,12.557,7.132,16.013,10.221,14.927,5.424-1.905-4.153-14.621,2.328-22.846C545.326,53.248,598.348,50.3,598.348,50.3",
    transform: "translate(-302.813 -6.742)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M579.583,9.457S515.168,32.149,509.225,32.68s-39.512,4.491-38.676,13.57c.8,8.673,24.412.79,34.158,1.739,7.769.757,11.62,8.154,18.825,24.913,5.4,12.557,7.132,16.013,10.221,14.927,5.424-1.905-4.153-14.621,2.328-22.846C545.326,53.248,598.348,50.3,598.348,50.3",
    transform: "translate(-302.813 -6.742)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M580.539,98.774s-24.821,17.013-21.755,22.649c2.947,5.415,34.669-7.177,48.049-26",
    transform: "translate(-365.545 -68.032)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M580.539,98.774s-24.821,17.013-21.755,22.649c2.947,5.415,34.669-7.177,48.049-26",
    transform: "translate(-365.545 -68.032)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M759.542,27.163s8.95,23.142,13.048,35.388l13.959-1.992s-7.73-28.01-10.857-38.983Z",
    transform: "translate(-508.863 -15.382)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M759.542,27.163s8.95,23.142,13.048,35.388l13.959-1.992s-7.73-28.01-10.857-38.983Z",
    transform: "translate(-508.863 -15.382)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M597.138,164.6c-6.107,13.7-6.215,21.228-7.125,29.846-.518,4.906-5.945,11.957-9.12,6.708-6.685-11.052.619-29.987.619-29.987Z",
    transform: "translate(-379.485 -117.355)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M597.138,164.6c-6.107,13.7-6.215,21.228-7.125,29.846-.518,4.906-5.945,11.957-9.12,6.708-6.685-11.052.619-29.987.619-29.987Z",
    transform: "translate(-379.485 -117.355)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M627.786,164.6c-4.964,8.719-9.619,36.476-4.5,34.779,6.047-2,9.2-27.659,9.2-27.659",
    transform: "translate(-410.133 -117.355)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M627.786,164.6c-4.964,8.719-9.619,36.476-4.5,34.779,6.047-2,9.2-27.659,9.2-27.659",
    transform: "translate(-410.133 -117.355)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M756.063,12.96l16.312-5.636-1.12-3.272a3.772,3.772,0,0,0-4.79-2.348L757.291,4.9a3.772,3.772,0,0,0-2.348,4.79Z",
    transform: "translate(-505.439 -1.069)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M756.063,12.96l16.312-5.636-1.12-3.272a3.772,3.772,0,0,0-4.79-2.348L757.291,4.9a3.772,3.772,0,0,0-2.348,4.79Z",
    transform: "translate(-505.439 -1.069)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M655.034,177.378s2.576,6.125,6.91,7.513",
    transform: "translate(-434.354 -126.463)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M655.034,177.378s2.576,6.125,6.91,7.513",
    transform: "translate(-434.354 -126.463)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHorizontalIcons);
export default __webpack_public_path__ + "static/media/groupHorizontalIcons.e2cb8eaa7f6459deaa25b8f22a3404d7.svg";
export { ForwardRef as ReactComponent };